import { useTranslation } from "react-i18next";

export default function Menu({ active, setActive, setOpenLogOut }) {
  const { t } = useTranslation();
  return (
    <div className="menu">
      <div className="items">
        <div
          className={active === "details" ? "item active" : "item"}
          onClick={() => setActive("details")}
        >
          <div className="icon">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="fi_266033">
                <g id="Group">
                  <g id="Group_2">
                    <path
                      id="Vector"
                      d="M15 13.421C18.7061 13.421 21.7105 10.4166 21.7105 6.71051C21.7105 3.0044 18.7061 0 15 0C11.2939 0 8.28949 3.0044 8.28949 6.71051C8.28949 10.4166 11.2939 13.421 15 13.421Z"
                      fill="white"
                    />
                  </g>
                </g>
                <g id="Group_3">
                  <g id="Group_4">
                    <path
                      id="Vector_2"
                      d="M15 15C8.45981 15 3.1579 20.302 3.1579 26.8421C3.1579 28.5861 4.57177 30 6.31581 30H23.6842C25.4283 30 26.8421 28.5861 26.8421 26.8421C26.8421 20.302 21.5402 15 15 15Z"
                      fill="white"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div className="text">
            <p>{t("profile-details")}</p>
          </div>
        </div>
        <div
          className={active === "orders" ? "item active" : "item"}
          onClick={() => setActive("orders")}
        >
          <div className="icon">
            <svg
              width="20"
              height="23"
              viewBox="0 0 20 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.77275 22.1042C6.4136 22.1057 6.06859 21.9644 5.81362 21.7114C5.55865 21.4585 5.4146 21.1146 5.41317 20.7555C5.41173 20.3963 5.55302 20.0513 5.80596 19.7964C6.0589 19.5414 6.40277 19.3973 6.76192 19.3959H6.77275C7.1319 19.3959 7.47633 19.5386 7.73029 19.7925C7.98425 20.0465 8.12692 20.3909 8.12692 20.7501C8.12692 21.1092 7.98425 21.4536 7.73029 21.7076C7.47633 21.9616 7.1319 22.1042 6.77275 22.1042ZM16.7936 20.7501C16.7936 20.3909 16.6509 20.0465 16.397 19.7925C16.143 19.5386 15.7986 19.3959 15.4394 19.3959H15.4286C15.1612 19.398 14.9005 19.4793 14.6792 19.6294C14.458 19.7795 14.2861 19.9917 14.1852 20.2393C14.0844 20.4869 14.0591 20.7589 14.1126 21.0208C14.1661 21.2828 14.2959 21.5231 14.4857 21.7114C14.6755 21.8997 14.9168 22.0276 15.1792 22.0789C15.4416 22.1303 15.7133 22.1029 15.9601 22.0001C16.2069 21.8973 16.4178 21.7237 16.5661 21.5013C16.7144 21.2788 16.7936 21.0174 16.7936 20.7501ZM19.7067 7.05673L18.6125 13.7517C18.5985 14.1441 18.502 14.5291 18.3292 14.8817C18.1564 15.2342 17.9112 15.5464 17.6097 15.7979C17.3082 16.0493 16.957 16.2344 16.5791 16.341C16.2013 16.4477 15.8052 16.4735 15.4167 16.4167H6.4575C5.93509 16.418 5.42992 16.2299 5.03554 15.8874C4.64115 15.5448 4.38428 15.0708 4.3125 14.5534L2.68642 3.23473C2.64392 2.90935 2.48408 2.6107 2.23692 2.39486C1.98976 2.17902 1.6723 2.06085 1.34417 2.06256H1.0625C0.847012 2.06256 0.640349 1.97696 0.487976 1.82459C0.335602 1.67221 0.25 1.46555 0.25 1.25006C0.25 1.03457 0.335602 0.82791 0.487976 0.675537C0.640349 0.523163 0.847012 0.437561 1.0625 0.437561H1.34417C2.06303 0.432948 2.75894 0.690415 3.30169 1.16179C3.84445 1.63316 4.19687 2.28614 4.293 2.99856L4.51942 4.50006H17.5833C17.9002 4.50122 18.213 4.57188 18.4996 4.70706C18.7862 4.84224 19.0397 5.03864 19.2422 5.28243C19.4446 5.52621 19.5912 5.81144 19.6714 6.11801C19.7517 6.42457 19.7637 6.74501 19.7067 7.05673ZM13.7992 8.43906C13.7238 8.36356 13.6342 8.30366 13.5356 8.2628C13.437 8.22193 13.3313 8.2009 13.2245 8.2009C13.1178 8.2009 13.0121 8.22193 12.9135 8.2628C12.8149 8.30366 12.7253 8.36356 12.6498 8.43906L10.3358 10.7531L9.46917 9.88639C9.316 9.73832 9.1108 9.65632 8.89776 9.65807C8.68472 9.65982 8.4809 9.74518 8.33018 9.89575C8.17946 10.0463 8.09392 10.2501 8.09197 10.4631C8.09002 10.6761 8.17182 10.8814 8.31975 11.0347L9.76383 12.4799C9.9165 12.6319 10.1231 12.7172 10.3385 12.7172C10.5539 12.7172 10.7606 12.6319 10.9132 12.4799L13.7992 9.59173C13.8752 9.51621 13.9355 9.42642 13.9767 9.32751C14.0179 9.2286 14.039 9.12253 14.039 9.0154C14.039 8.90826 14.0179 8.80219 13.9767 8.70328C13.9355 8.60437 13.8752 8.51457 13.7992 8.43906Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text">
            <p>{t('orders')}</p>
          </div>
        </div>
        <div
          className={active === "favourites" ? "item active" : "item"}
          onClick={() => setActive("favourites")}
        >
          <div className="icon">
            <svg
              width="22"
              height="20"
              viewBox="0 0 22 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 19.5135C10.8887 19.5135 10.7775 19.4848 10.6778 19.4272C10.5695 19.3647 7.99692 17.8711 5.38744 15.6204C3.84082 14.2866 2.60625 12.9636 1.71808 11.6883C0.568758 10.038 -0.00921316 8.45065 0.000111035 6.97025C0.0110251 5.24764 0.628012 3.62763 1.73755 2.40861C2.86582 1.16905 4.37153 0.48645 5.9774 0.48645C8.03547 0.48645 9.91711 1.6393 11 3.46555C12.083 1.63934 13.9646 0.48645 16.0227 0.48645C17.5398 0.48645 18.9873 1.10236 20.0987 2.22075C21.3183 3.44807 22.0112 5.18219 21.9999 6.97841C21.9905 8.45623 21.4017 10.0412 20.2499 11.6892C19.359 12.9638 18.1261 14.2862 16.5855 15.6197C13.9856 17.8701 11.4315 19.3637 11.324 19.4262C11.2239 19.4844 11.1119 19.5135 11 19.5135Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text">
            <p>{t('favourites')}</p>
          </div>
        </div>
        <div
          className={active === "addresses" ? "item active" : "item"}
          onClick={() => setActive("addresses")}
        >
          <div className="icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_190_6210)">
                <path
                  d="M11 0C6.4515 0 2.75 3.72717 2.75 8.30958C2.75 14.8207 10.2245 21.5435 10.5426 21.8258C10.6737 21.9422 10.8368 22 11 22C11.1632 22 11.3263 21.9423 11.4574 21.8268C11.7755 21.5435 19.25 14.8207 19.25 8.30958C19.25 3.72717 15.5485 0 11 0ZM11 12.8333C8.47275 12.8333 6.41667 10.7773 6.41667 8.25C6.41667 5.72275 8.47275 3.66667 11 3.66667C13.5273 3.66667 15.5833 5.72275 15.5833 8.25C15.5833 10.7773 13.5273 12.8333 11 12.8333Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_190_6210">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="text">
            <p>{t('addresses')}</p>
          </div>
        </div>
        <div
          className={active === "promo" ? "item active" : "item"}
          onClick={() => setActive("promo")}
        >
          <div className="icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.2398 11.0001C20.2398 10.5749 19.334 10.2187 19.2757 9.8095C19.2159 9.39018 19.9843 8.79464 19.8677 8.39644C19.7489 7.99142 18.7796 7.90518 18.6065 7.52678C18.4305 7.14398 18.9996 6.35484 18.7737 6.00394C18.5477 5.65304 17.5921 5.84158 17.3182 5.52566C17.0443 5.20974 17.3674 4.29146 17.0509 4.0169C16.7343 3.74234 15.8725 4.1929 15.5197 3.96608C15.1668 3.73926 15.222 2.7684 14.8392 2.59328C14.4608 2.42014 13.7612 3.09532 13.356 2.97674C12.9578 2.86014 12.7338 1.91282 12.3145 1.85298C11.9053 1.79468 11.425 2.64014 10.9998 2.64014C10.5745 2.64014 10.0942 1.79468 9.68505 1.85298C9.26573 1.91282 9.04177 2.86014 8.64357 2.97674C8.23855 3.09532 7.53895 2.42014 7.16033 2.59328C6.77753 2.76928 6.83033 3.74014 6.47987 3.96608C6.12941 4.19202 5.26459 3.743 4.94867 4.0169C4.63275 4.2908 4.95593 5.20908 4.68137 5.52566C4.40681 5.84224 3.45377 5.65084 3.22585 6.00394C2.99793 6.35704 3.56817 7.14398 3.39305 7.52678C3.21991 7.90518 2.25059 7.99142 2.13179 8.39644C2.01519 8.79464 2.78365 9.39018 2.72381 9.8095C2.66551 10.2187 1.75977 10.5749 1.75977 11.0001C1.75977 11.4254 2.66551 11.7816 2.72381 12.1908C2.78365 12.6101 2.01519 13.2056 2.13179 13.6038C2.25059 14.0089 3.21991 14.0951 3.39305 14.4735C3.56905 14.8563 2.99991 15.6454 3.22585 15.9963C3.45179 16.3472 4.40747 16.1587 4.68137 16.4746C4.95527 16.7905 4.63209 17.7088 4.94867 17.9834C5.26525 18.2579 6.12699 17.8074 6.47987 18.0342C6.83275 18.261 6.77753 19.2319 7.16033 19.407C7.53873 19.5801 8.23833 18.905 8.64357 19.0235C9.04177 19.1404 9.26573 20.0875 9.68505 20.1473C10.0942 20.2056 10.5745 19.3601 10.9998 19.3601C11.425 19.3601 11.9053 20.2056 12.3145 20.1473C12.7338 20.0875 12.9578 19.1401 13.356 19.0235C13.761 18.905 14.4606 19.5801 14.8392 19.407C15.222 19.231 15.1692 18.2601 15.5197 18.0342C15.8701 17.8083 16.7349 18.2573 17.0509 17.9834C17.3668 17.7095 17.0436 16.7912 17.3182 16.4746C17.5927 16.158 18.5464 16.3494 18.7737 15.9963C19.0009 15.6432 18.4314 14.8563 18.6065 14.4735C18.7796 14.0951 19.7489 14.0089 19.8677 13.6038C19.9843 13.2056 19.2159 12.6101 19.2757 12.1908C19.334 11.7816 20.2398 11.4254 20.2398 11.0001ZM7.00941 9.33364C6.77961 9.10383 6.62312 8.81105 6.55972 8.4923C6.49633 8.17356 6.52887 7.84317 6.65324 7.54293C6.77761 7.24268 6.98822 6.98605 7.25844 6.8055C7.52866 6.62495 7.84635 6.52858 8.17134 6.52858C8.49632 6.52858 8.81401 6.62495 9.08423 6.8055C9.35445 6.98605 9.56506 7.24268 9.68943 7.54293C9.8138 7.84317 9.84634 8.17356 9.78295 8.4923C9.71955 8.81105 9.56306 9.10383 9.33327 9.33364C9.18068 9.48623 8.99954 9.60727 8.80017 9.68986C8.60081 9.77244 8.38713 9.81494 8.17134 9.81494C7.95554 9.81494 7.74187 9.77244 7.5425 9.68986C7.34314 9.60727 7.16199 9.48623 7.00941 9.33364ZM8.63301 14.6114C8.55129 14.6932 8.45427 14.758 8.34751 14.8022C8.24074 14.8464 8.1263 14.8692 8.01074 14.8692C7.89517 14.8692 7.78074 14.8464 7.67397 14.8022C7.5672 14.758 7.47018 14.6932 7.38847 14.6114C7.30675 14.5297 7.24193 14.4327 7.1977 14.3259C7.15348 14.2192 7.13071 14.1047 7.13071 13.9892C7.13071 13.8736 7.15348 13.7592 7.1977 13.6524C7.24193 13.5456 7.30675 13.4486 7.38847 13.3669L13.3665 7.38884C13.4482 7.30712 13.5453 7.2423 13.652 7.19807C13.7588 7.15385 13.8732 7.13109 13.9888 7.13109C14.1044 7.13109 14.2188 7.15385 14.3256 7.19807C14.4323 7.2423 14.5293 7.30712 14.6111 7.38884C14.6928 7.47056 14.7576 7.56757 14.8018 7.67434C14.8461 7.78111 14.8688 7.89554 14.8688 8.01111C14.8688 8.12668 14.8461 8.24111 14.8018 8.34788C14.7576 8.45465 14.6928 8.55166 14.6111 8.63338L8.63301 14.6114ZM14.991 14.9905C14.7612 15.2203 14.4684 15.3768 14.1497 15.4402C13.8309 15.5036 13.5005 15.471 13.2003 15.3467C12.9 15.2223 12.6434 15.0117 12.4629 14.7415C12.2823 14.4712 12.1859 14.1536 12.1859 13.8286C12.1859 13.5036 12.2823 13.1859 12.4629 12.9157C12.6434 12.6455 12.9 12.4348 13.2003 12.3105C13.5005 12.1861 13.8309 12.1536 14.1497 12.217C14.4684 12.2804 14.7612 12.4368 14.991 12.6666C15.1435 12.8193 15.2645 13.0005 15.347 13.1999C15.4295 13.3993 15.472 13.613 15.4719 13.8288C15.4718 14.0445 15.4292 14.2582 15.3465 14.4575C15.2639 14.6569 15.1428 14.838 14.9901 14.9905H14.991Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text">
            <p>{t('promo-codes')}</p>
          </div>
        </div>
      </div>
      <div className="log-out" onClick={() => setOpenLogOut(true)}>
        <div className="item">
          <div className="icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.2359 0H10.4672C8.3875 0 6.70312 1.68437 6.70312 3.76406V9.18242H10.2437L9.97734 8.91602C9.27695 8.19844 9.28555 7.05117 10.0031 6.34648C10.7078 5.65469 11.8422 5.65469 12.5469 6.34648L15.9156 9.71523C16.6246 10.4242 16.6246 11.5758 15.9156 12.2848L12.5469 15.6535C11.8465 16.3711 10.6949 16.3797 9.97734 15.6793C9.25977 14.9789 9.25117 13.8273 9.95156 13.1098L9.97734 13.084L10.2437 12.8176H6.70312V18.2359C6.70312 20.3156 8.3875 22 10.4672 22H18.2359C20.3156 22 22 20.3156 22 18.2359V3.76406C22 1.68437 20.3156 0 18.2359 0Z"
                fill="#FEAC7A"
              />
              <path
                d="M10.4715 13.5825C10.0375 14.0165 10.0375 14.7212 10.4715 15.1552C10.9055 15.5892 11.6102 15.5892 12.0441 15.1552L15.4129 11.7864C15.8469 11.3524 15.8469 10.6478 15.4129 10.2138L12.0441 6.84502C11.6102 6.41104 10.9055 6.41104 10.4715 6.84502C10.0375 7.279 10.0375 7.98369 10.4715 8.41768L11.9453 9.88721H1.05703C0.472656 9.88721 0 10.3599 0 10.9442V11.0517C0 11.636 0.472656 12.1087 1.05703 12.1087H11.9453L10.4715 13.5825Z"
                fill="#FEAC7A"
              />
            </svg>
          </div>
          <div className="text">
            <p>{t('log-out')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
